module.exports = __webpack_public_path__ + "img/product-placeholder-61.2333261.png";